import { client } from "api";
import { Company } from "models/Company";
import { CompanyOffice } from "models/CompanyOffice";

export type DeleteOfficeRequest = { companyId: Company["id"] } & Pick<CompanyOffice, "id">;

export type DeleteOfficeResponse = CompanyOffice[];

export const deleteOffice = ({ companyId, id }: DeleteOfficeRequest) =>
  client.delete<DeleteOfficeResponse>(`/company/${companyId}/offices/${id}`).then((res) => res.data);
